import Icon from 'vue-awesome/components/Icon'

Icon.register({
  brightness_2_sharp: {
    paths: [
      {
        d: 'M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z'
      }
    ],
    width: '24',
    height: '24'
  }
})
